export function AnalyticsPanel({ analytics, showAnalytics, setShowAnalytics }) {
  return (
    <div className="mt-8">
      <button
        onClick={() => setShowAnalytics(!showAnalytics)}
        className="flex items-center gap-2 text-lg font-bold mb-4"
        data-testid="toggle-analytics"
      >
        <span className={`transform transition-transform ${showAnalytics ? "rotate-90" : ""}`}>&#9654;</span>
        Performance Analytics (Last 30 Days)
      </button>
      {showAnalytics && analytics && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <div className="bg-white border border-black p-4" data-testid="analytics-clicks">
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-1">Link Clicks</p>
              <p className="text-3xl font-black">{analytics.total_clicks}</p>
            </div>
            <div className="bg-white border border-black p-4" data-testid="analytics-signups">
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-1">Signups</p>
              <p className="text-3xl font-black">{analytics.total_signups}</p>
            </div>
            <div className="bg-white border border-black p-4" data-testid="analytics-paid">
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-1">Paid Users</p>
              <p className="text-3xl font-black text-green-600">{analytics.paid_conversions}</p>
            </div>
            <div className="bg-white border border-black p-4" data-testid="analytics-ctr">
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-1">Click &rarr; Signup</p>
              <p className="text-3xl font-black text-[#0066FF]">{analytics.click_to_signup_rate}%</p>
            </div>
            <div className="bg-white border border-black p-4" data-testid="analytics-conversion">
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-1">Signup &rarr; Paid</p>
              <p className="text-3xl font-black text-[#0066FF]">{analytics.signup_to_paid_rate}%</p>
            </div>
          </div>
          {analytics.clicks_by_source?.length > 0 && (
            <div className="bg-white border border-black p-6">
              <h3 className="text-lg font-bold mb-4">Clicks by Source</h3>
              <div className="space-y-3">
                {analytics.clicks_by_source.map((s) => (
                  <div key={s.source} className="flex items-center gap-4" data-testid={`source-${s.source}`}>
                    <span className="w-24 text-sm font-medium capitalize">{s.source}</span>
                    <div className="flex-1 bg-gray-100 h-6 relative">
                      <div
                        className="absolute left-0 top-0 h-full bg-[#0066FF]"
                        style={{ width: `${Math.min((s.clicks / analytics.total_clicks) * 100, 100)}%` }}
                      />
                      <span className="absolute right-2 top-0 h-full flex items-center text-sm font-bold">
                        {s.clicks}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {analytics.revenue_by_plan?.length > 0 && (
            <div className="bg-white border border-black p-6">
              <h3 className="text-lg font-bold mb-4">Revenue by Plan</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {analytics.revenue_by_plan.map((p) => (
                  <div key={p.plan} className="border border-gray-200 p-4" data-testid={`revenue-${p.plan}`}>
                    <p className="text-sm text-gray-500 capitalize">{p.plan} Plan</p>
                    <p className="text-2xl font-black text-green-600">${p.revenue}</p>
                    <p className="text-xs text-gray-400">{p.count} conversions</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
